import { useCallback } from "react";
import { MolstarWrapper } from "@loschmidt/molstar";
import { PluginCommands } from 'molstar/lib/mol-plugin/commands';
import { StateObjectSelector } from "molstar/lib/mol-state/object";

export function useRemoveObject(viewer: MolstarWrapper | undefined) {
  return useCallback(async (selector: StateObjectSelector) => {
    if (viewer) {
      // noinspection TypeScriptValidateJSTypes
      return PluginCommands.State.RemoveObject(viewer.plugin, {
        state: viewer.plugin.state.data,
        ref: selector.ref,
      });
    }
  }, [viewer]);
}